import { render, staticRenderFns } from "./OrderLocation.vue?vue&type=template&id=b9646a50&scoped=true&"
import script from "./OrderLocation.vue?vue&type=script&lang=js&"
export * from "./OrderLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9646a50",
  null
  
)

export default component.exports